
function Hamburger() {
  var drawer = document.querySelector(".drawer1");
  drawer.classList.toggle("open");

  var hamopen = document.querySelector(".hamopen");
  var hamclose = document.querySelector(".hamclose");
  var pnavbar = document.querySelector(".p-navbar");


 
  if (hamopen.style.display === "none") {
    hamopen.style.display = "flex"; // Show menu icon
    hamclose.style.display = "none"; // Hide close icon
      pnavbar.style.display = "block"; // show pnavbar
  } else {
    hamopen.style.display = "none"; // Hide menu icon
    hamclose.style.display = "flex"; // Show close icon
      pnavbar.style.display = "none"; // Hide show pnavbar
  }

  var bodyOverflow = document.querySelector("body");
  bodyOverflow.classList.toggle("overflow");
}



document.addEventListener("DOMContentLoaded", function() {
    const boxes = document.querySelectorAll(".box");

    boxes.forEach(box => {
        const video = box.querySelector('.video');

        box.addEventListener("mouseenter", function() {
            video.play();
        });

        box.addEventListener("mouseleave", function() {
            video.pause();
        });
    });
});


// nilesh count down starts from here

// (function () {
//   const second = 1000,
//         minute = second * 60,
//         hour = minute * 60,
//         day = hour * 24;

//   // Set the target date and time
//   let birthday = "12/20/2024 00:00:00";

//   const countDown = new Date(birthday).getTime(),
//       x = setInterval(function() {    

//         const now = new Date().getTime(),
//               distance = countDown - now;

//         // Helper function to format numbers with leading zeros
//         const formatNumber = (num) => (num < 10 ? `0${num}` : num);

//         document.getElementById("days").innerText = `${formatNumber(Math.floor(distance / day))}`;
//         document.getElementById("hours").innerText = `${formatNumber(Math.floor((distance % day) / hour))}`;
//         document.getElementById("minutes").innerText = `${formatNumber(Math.floor((distance % hour) / minute))}`;
//         document.getElementById("seconds").innerText = `${formatNumber(Math.floor((distance % minute) / second))}`;

//         // Do something later when the date is reached
//         if (distance < 0) {
//           document.getElementById("headline").innerText = "DROP IS LIVE!";
//           document.getElementById("countdown").style.display = "none";
//           document.getElementById("content").style.display = "block";
//           clearInterval(x);
//         }
//       }, 1000); // Adjusted interval to 1000ms (1 second)
// })();

(function () {
  const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;

  // Set the target date and time in IST
  const targetDate = new Date("2024-12-20T00:00:00"); // Target time in IST

  const countDown = targetDate.getTime();

  const x = setInterval(function () {
    // Get the current time
    const now = new Date().getTime();

    const distance = countDown - now;

    // Helper function to format numbers with leading zeros
    const formatNumber = (num) => (num < 10 ? `0${num}` : num);

    // Update the countdown values
    document.getElementById("days").innerText = `${formatNumber(Math.floor(distance / day))}`;
    document.getElementById("hours").innerText = `${formatNumber(Math.floor((distance % day) / hour))}`;
    document.getElementById("minutes").innerText = `${formatNumber(Math.floor((distance % hour) / minute))}`;
    document.getElementById("seconds").innerText = `${formatNumber(Math.floor((distance % minute) / second))}`;

    // When the countdown reaches zero
    if (distance < 0) {
      document.getElementById("headline").innerText = "DROP IS LIVE!";
      document.getElementById("countdown").style.display = "none";
      document.getElementById("content").style.display = "block";
      clearInterval(x);
    }
  }, 1000); // 1-second interval
})();


// nilesh count down ends here

// size guide

function sizeGuide() {
    const sizeContainer = document.querySelector(".size-body-container");
    sizeContainer.classList.toggle("open");

    // Add Intersection Observer to close size chart when .related-products enters viewport
    if (sizeContainer.classList.contains("open")) {
        const relatedProducts = document.querySelector(".related-products");
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    removeGuide(); // Close size chart when .related-products enters viewport
                }
            });
        });

        observer.observe(relatedProducts);
    }
}

function removeGuide() {
    const sizeContainer = document.querySelector(".size-body-container");
    sizeContainer.classList.remove("open");

    // Remove scroll event listener when size chart is closed
    window.removeEventListener("scroll", closeSizeChartOnScroll);
}

// Event listener for scrolling to close size chart after 100px scroll
// function closeSizeChartOnScroll() {
//     if (window.scrollY >= 100) {
//         removeGuide();
//     }
// }

document.addEventListener("DOMContentLoaded", function () {
    const stocklistLink = document.querySelector(".stocklist");
    const popup = document.getElementById("popup");
    const popupContent = document.querySelector(".popup-content");

    stocklistLink.addEventListener("click", function (event) {
        event.preventDefault();
        popup.style.display = "block";
    });

    document.addEventListener("click", function (event) {
        if (!popupContent.contains(event.target) && event.target !== stocklistLink) {
            popup.style.display = "none";
        }
    });
});



// document.querySelector(".gradient").addEventListener("click", removeGuide());









// document.addEventListener("DOMContentLoaded", function () {
//     const stocklistLink = document.querySelector(".stocklist");
//     const popup = document.getElementById("popup");
//     const popupContent = document.querySelector(".popup-content");

//     stocklistLink.addEventListener("click", function (event) {
//         event.preventDefault();
//         popup.style.display = "block";
//     });

//     // Close the popup when clicking outside of it
//     document.addEventListener("click", function (event) {
//         if (!popupContent.contains(event.target) && event.target !== stocklistLink) {
//             popup.style.display = "none";
//         }
//     });
// });



// Get the dropdown toggle element
var dropdownToggle = document.querySelector('.dropdown-toggle');

// Get the dropdown menu element
var dropdownMenu = document.querySelector('.dropdown-li');

// Toggle function for showing/hiding dropdown
function toggleDropdown() {
    if (dropdownMenu.style.display === 'block') {
        dropdownMenu.style.display = 'none';
    } else {
        dropdownMenu.style.display = 'block';
    }
}

// Event listener for toggle
dropdownToggle.addEventListener('click', function(e) {
    e.preventDefault();
    toggleDropdown();
});

// Close the dropdown if clicked outside
document.addEventListener('click', function(event) {
    var isClickInside = dropdownToggle.contains(event.target) || dropdownMenu.contains(event.target);
    if (!isClickInside) {
        dropdownMenu.style.display = 'none';
    }
});



// Get the dropdown toggle element
var dropdownToggle2 = document.querySelector('.dropdown-toggle2');

// Get the dropdown menu element
var dropdownMenu2 = document.querySelector('.dropdown-li2');

// Toggle function for showing/hiding dropdown
function toggleDropdown2() {
    if (dropdownMenu2.style.display === 'block') {
        dropdownMenu2.style.display = 'none';
    } else {
        dropdownMenu2.style.display = 'block';
    }
}

// Event listener for toggle
dropdownToggle2.addEventListener('click', function(e) {
    e.preventDefault();
    toggleDropdown2();
});

// Close the dropdown if clicked outside
document.addEventListener('click', function(event) {
    var isClickInside = dropdownToggle2.contains(event.target) || dropdownMenu2.contains(event.target);
    if (!isClickInside) {
        dropdownMenu2.style.display = 'none';
    }
});



// let isFormRelative = false;

// function handleProductFormScroll() {
//   const productForm = document.querySelector('.product-form');
//   const productFormButtons = document.querySelector('.product-form__buttons');
  
//   const productFormPosition = productForm.getBoundingClientRect().top;
//   const windowHeight = window.innerHeight;

//   if (productFormPosition < windowHeight && !isFormRelative) {
//     productFormButtons.style.position = 'relative';
//     isFormRelative = true;
//   } else if (productFormPosition >= windowHeight && isFormRelative) {
//     productFormButtons.style.position = 'fixed';
//     isFormRelative = false;
//   }
// }

// window.addEventListener('scroll', handleProductFormScroll);



// for filter display none on footer enter
function handleFooterSectionScroll() {
  const footerSection = document.querySelector('.footer-section');
  const facetsContainer = document.querySelector('.facets-container');

  const footerSectionPosition = footerSection.getBoundingClientRect().top;
  const windowHeight = window.innerHeight;
  const scrollTriggerPoint = windowHeight; // Adjust this value as needed

  if (footerSectionPosition < scrollTriggerPoint) {
    facetsContainer.classList.add('hide-facets');
  } else {
    facetsContainer.classList.remove('hide-facets');
  }
}


window.addEventListener('scroll', handleFooterSectionScroll);



// let lastScrollTop = 0; // Variable to track the last scroll position

// function handleScroll() {
//   const shopAllLink = document.querySelector('.hero-section .shop-all');
//   const footerSection = document.querySelector('.footer-section');

//   const footerSectionPosition = footerSection.getBoundingClientRect().top;
//   const windowHeight = window.innerHeight;
//   const scrollPosition = window.scrollY || window.pageYOffset;

//   if (scrollPosition > lastScrollTop) {
//     // Scrolling down
//     shopAllLink.style.display = 'none';
//   } else {
//     // Scrolling up
//     if (footerSectionPosition > windowHeight) {
//       shopAllLink.style.display = 'block';
//     }
//   }

//   lastScrollTop = scrollPosition <= "80%" ? 0 : scrollPosition; // For Mobile or negative scrolling
// }

// window.addEventListener('scroll', handleScroll);

let lastScrollTop = 0; // Variable to track the last scroll position
let isShopAllVisible = true;

function handleScroll() {
  const shopAllLink = document.querySelector('.hero-section .shop-all');
  const windowHeight = window.innerHeight;
  const shopAllPosition = shopAllLink.getBoundingClientRect().top;

  if (shopAllPosition < windowHeight * 0.2 && shopAllPosition > 0) {
    shopAllLink.style.display = 'none';
    isShopAllVisible = false;
  } else if (lastScrollTop > window.scrollY && !isShopAllVisible) {
    shopAllLink.style.display = 'block';
    isShopAllVisible = true;
  }

  lastScrollTop = window.scrollY || window.pageYOffset;
}

window.addEventListener('scroll', handleScroll);
  // Attaching click event listener to toggle the class
  document.querySelector(".size-body-container").addEventListener("click", sizeGuide);





